import React from "react";
import { useI18n } from "@/lib/i18n";

export default function LanguageSwitcher({ testId }) {
    const { locale, toggle } = useI18n();
    return (
        <button
            type="button"
            onClick={toggle}
            data-testid={testId || "lang-toggle"}
            className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-mono text-zinc-300 hover:text-white border border-white/10 hover:border-white/25 hover:bg-white/5 transition"
            aria-label="Toggle language"
        >
            <span className={locale === "en" ? "text-white font-semibold" : "text-zinc-500"}>EN</span>
            <span className="text-zinc-600">/</span>
            <span className={locale === "fr" ? "text-white font-semibold" : "text-zinc-500"}>FR</span>
        </button>
    );
}
